/**
 * Chat deep link URL construction and parsing.
 * Enables shareable URLs like: https://skjv.ai/?chat=What+does+John+3:16+mean%3F
 */

/** Build a chat deep link URL with optional hash for Bible location */
export function buildChatDeepLink(message: string, hash?: string): string {
  const origin = typeof window !== 'undefined' ? window.location.origin : 'https://skjv.ai';
  const basePath = import.meta.env.BASE_URL ?? '/';
  const url = new URL(basePath, origin);
  url.searchParams.set('chat', message);
  return hash ? `${url.toString()}${hash}` : url.toString();
}

/** Parse the ?chat= query parameter from the current URL */
export function parseChatParam(): string | null {
  if (typeof window === 'undefined') return null;
  const params = new URLSearchParams(window.location.search);
  const chat = params.get('chat');
  return chat?.trim() || null;
}

/** Remove ?chat= from the URL without a page reload, preserving hash */
export function clearChatParam(): void {
  if (typeof window === 'undefined') return;
  const url = new URL(window.location.href);
  url.searchParams.delete('chat');
  const clean = url.pathname + (url.search || '') + url.hash;
  window.history.replaceState(null, '', clean);
}
